// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__nN1ue","childskill":"Skill_childskill__raWVF"};